export function normalizeStatus(value) {
  if (value === true || value === 1) return true;
  return ["true", "1", "yes"].includes(String(value ?? "").trim().toLowerCase());
}

export function formatClientDisplayName(value) {
  const name = String(value || "").trim();
  return name ? `${name.charAt(0).toUpperCase()}${name.slice(1)}` : "—";
}

export function getCurrentSipClientLabel(complex) {
  const currentId = String(complex?.currentSipClientId || "");
  const client = normalizeComplexSipClients(complex?.sipClients)
    .find((item) => String(item?._id || "") === currentId);
  return formatClientDisplayName(client?.clientName || complex?.currentSipClient);
}

export function normalizeComplexSipClients(value) {
  if (Array.isArray(value)) {
    return value.filter((client) => client && typeof client === "object");
  }

  if (value && typeof value === "object") {
    return Object.values(value).filter((client) => client && typeof client === "object");
  }

  return [];
}

export function buildSipRows(complexes) {
  return complexes.flatMap((complex) => {
    const clients = normalizeComplexSipClients(complex?.sipClients);

    return clients.map((client) => ({
      complex,
      complexId: complex?._id,
      complexName: complex?.name || "Без названия",
      city: complex?.city || "",
      complexStatus: complex?.status,
      sipClientId: String(client?._id || ""),
      currentSipClientId: String(complex?.currentSipClientId || ""),
      currentSipClient: complex?.currentSipClient || "",
      isCurrentClient:
        Boolean(client?._id) && String(complex?.currentSipClientId || "") === String(client._id),
      clientName: client?.clientName || "",
      clientStatus: typeof client?.status === "undefined" ? true : normalizeStatus(client.status),
      sip_number: client?.sip_number ?? "",
      transfer_number: client?.transfer_number ?? "",
      type: client?.type || "",
    }));
  });
}

function getTransferSortValue(value) {
  const text = String(value ?? "").trim();

  if (!text) {
    return { empty: true, number: Number.POSITIVE_INFINITY, text: "" };
  }

  const number = Number(text);

  return {
    empty: false,
    number: Number.isFinite(number) ? number : Number.POSITIVE_INFINITY,
    text,
  };
}

export function compareTransferRows(left, right) {
  const leftValue = getTransferSortValue(left.transfer_number);
  const rightValue = getTransferSortValue(right.transfer_number);

  if (leftValue.empty !== rightValue.empty) {
    return leftValue.empty ? 1 : -1;
  }

  if (leftValue.number !== rightValue.number) {
    return leftValue.number - rightValue.number;
  }

  return leftValue.text.localeCompare(rightValue.text, "ru");
}

export function getDuplicateTransferNumbers(rows) {
  const counts = new Map();

  for (const row of rows) {
    const key = String(row.transfer_number ?? "").trim();

    if (!key) continue;

    counts.set(key, (counts.get(key) || 0) + 1);
  }

  return new Set(
    Array.from(counts.entries())
      .filter(([, count]) => count > 1)
      .map(([key]) => key)
  );
}

export function getRowClientName(row) {
  return String(row?.clientName || "").trim();
}
